import {
  Bell,
  ChartNoAxesCombined,
  CreditCard,
  House,
  SettingsIcon,
  Smartphone,
  Users,
  UsersRound,
  type LucideIcon,
} from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import type { NavItemId } from '@/lib/navigation';

export const NAV_ITEM_ICONS: Record<NavItemId, LucideIcon> = {
  home: House,
  campaigns: Bell,
  analytics: ChartNoAxesCombined,
  app: Smartphone,
  audiences: Users,
  team: UsersRound,
  billing: CreditCard,
  settings: SettingsIcon,
};

/** Label of each destination, the same in the sidebar, tab bar and Mais. */
export function useNavItemLabel(): (id: NavItemId) => string {
  const { LL } = useI18nContext();
  return (id) => {
    switch (id) {
      case 'home':
        return LL.dashboard();
      case 'campaigns':
        return LL.campaigns.title();
      case 'analytics':
        return LL.metrics();
      case 'app':
        return LL.appCustomization();
      case 'audiences':
        return LL.audiences.title();
      case 'team':
        return LL.team.sidebarLabel();
      case 'billing':
        return LL.billing();
      case 'settings':
        return LL.settingsPage.title();
    }
  };
}
